import useSWR from "swr";

type RankCard = {
  img: string;
}

export const useFetchRankCardByRestaurantId = (restaurantId: string) => {
  const { data: rankCard, error, isLoading } = useSWR<RankCard>(`membership/restaurants/${restaurantId}/rank-card/`)
  return { rankCard, isLoading, error };
};